export function resolveReturnTo(redirectQuery, currentOrigin) {
  const match = (redirectQuery || "").match(/[?&]return_to=([^&]+)/);
  if (!match) return null;
  try {
    const parsed = new URL(decodeURIComponent(match[1]), currentOrigin);
    if (parsed.origin !== currentOrigin) return null;
    return { pathname: parsed.pathname, search: parsed.search };
  } catch (_) {
    return null;
  }
}
